import React, { Component } from "react";
import { Grid, Row, Col, Table } from "react-bootstrap";
import Card from "../../components/Card/Card.jsx";
import { NavLink } from "react-router-dom";
import gql from "graphql-tag";

import { ApolloClient } from 'apollo-client';
import { Query } from "react-apollo";
import { InMemoryCache } from 'apollo-cache-inmemory';
import { HttpLink } from 'apollo-link-http';

import Select from 'react-select';
import { FormInputs } from "../../components/FormInputs/FormInputs.jsx";
import Button from "../../components/CustomButton/CustomButton.jsx";


const restLink_cloud = new HttpLink({ 
  uri: "/api/v1/cloud/",
  credentials: 'include'  
});
const account_cloud = new ApolloClient({
  link: restLink_cloud,
  cache: new InMemoryCache(),
});

const CREATE_SUBNETIPAM_HAS_ACCOUNT = gql`
  mutation createSubnetipamHasAccount($subnet_id: Int!, $account_id: Int!){
    createSubnetipamHasAccount(subnet_id:$subnet_id, account_id: $account_id) {
      id
    }
  }
`;

const DELETE_SUBNETIPAM_HAS_ACCOUNT = gql`
mutation deleteSubnetipamHasAccount($subnet_id: Int!, $account_id: Int!){
  deleteSubnetipamHasAccount(subnet_id:$subnet_id, account_id: $account_id) {
    id
  }
}
`;
const GET_SUBNETIPAM_HAS_ACCOUNT = gql`
  query subnetipamHasAccount_collection($account_id: Int!){
    subnetipamHasAccount_collection(account_id: $account_id) {
      subnetsHasAccount{
        id
        subnet{
          value:id
          label:description
        }
      }
    }
  }
`;


const GET_SUBNETIPAM = gql`
{
  subnetIpam_collection{
    subnets{
      value:id
      label:description
    }
  }
}
`;




class SubnetipamHasAccount extends Component {

  controllerItens = [];
  urlBack;

  constructor() {
    super();
     this.state = {
       defaultOptions : [],
    }

  }

  
  onChange = (inputValue, action ) => {
    
    // Adicionar
    if(action.action === 'select-option') {
      account_cloud.mutate({
        mutation: CREATE_SUBNETIPAM_HAS_ACCOUNT,
        variables: {
          subnet_id: action.option.value, account_id: parseInt(this.props.match.params.account_id)
        }
      });
    } 
    // Remover
    else if(action.action === 'remove-value') {
      
      account_cloud.mutate({
        mutation: DELETE_SUBNETIPAM_HAS_ACCOUNT,
        variables: {
          subnet_id: action.removedValue.value, account_id: parseInt(this.props.match.params.account_id)
        }
      });
    }
 
  } 

  onInputChange = (inputValue, action ) => {

    
    /*
    account_cloud.mutate({
      mutation: CREATE_SUBNETIPAM_HAS_ACCOUNT,
      variables: {
        account_module_id: inputValue, profile_id: this.props.match.params.account_id
      }
    });
    */
    
  }


  handleSubmit = (event) => {
    event.preventDefault();
    

  }

  render() {
    
    
    return (

      <div className="content">
        <Grid fluid>
          <Row>
            <Col md={12}>
              <a
                  href='javascript:history.go(-1)'
                  className="btn btn-info btn-fill"
                >
                VOLTAR
              </a>

              <Card
                title={"Subnets IPAM"}
                category=""
                ctTableFullWidth
                ctTableResponsive
                content={

                  <form 
                  onSubmit={e => {
                    this.handleSubmit(e);
                    e.preventDefault();
                  }}
                  >
                  
                  <Table striped hover>
                    <thead>
                      <tr>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>

                    <Query
                        client={account_cloud}
                        query={GET_SUBNETIPAM}
                      >
                        {({ loading, error, data }) => {

                          if (loading) return <tr><td>Carregando...</td></tr>;
                          if (error) return <tr><td>Erro :( x</td></tr>;

                                var select_options = data.subnetIpam_collection.subnets;
                               
                                return (
                        
                                <Query
                                  client={account_cloud}
                                  variables={{account_id:this.props.match.params.account_id}}
                                  query={GET_SUBNETIPAM_HAS_ACCOUNT}
                                >
                                  {({ loading, error, data }) => {

                                    if (loading) return <tr><td>Carregando...</td></tr>;
                                    if (error) return <tr><td>Erro :(</td></tr>;

                                      var defaultValues = [];
                                      data.subnetipamHasAccount_collection.subnetsHasAccount.map((SubnetipamHasAccount) => {
                                        var SubnetipamHasAccount = SubnetipamHasAccount.subnet;
                                        defaultValues.push(SubnetipamHasAccount); 
                                      });
                                      return (
                                          <tr>
                                            <td>
                                              <Select
                                                    defaultValue={this.state.defaultValue && this.state.defaultValue ? this.state.defaultValue : defaultValues}
                                                    isMulti
                                                    isSearchable
                                                    name={"values"}
                                                    options={select_options}
                                                    className="basic-multi-select"
                                                    classNamePrefix="select"
                                                    //inputValue={inputValue}
                                                    onChange={this.onChange}
                                                    //onInputChange={this.onInputChange}
                                                    isClearable={false}
                                                  />
                                            </td>
                                          </tr>
                                      );
                                  }}
                                </Query>
                                );
                              }}
                            </Query>
                          
                        <tr>
                          <td>
                          <Button bsStyle="info" pullRight fill onClick={() => {window.location.reload()}}>
                            Salvar
                          </Button>
                          </td>
                          <td></td>
                        </tr>
                    </tbody>
                  </Table>
                  

                  </form>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default SubnetipamHasAccount;
